export const STORAGE_PRODUCT_UUID_KEY = 'braincube-product-uuid';
export const STORAGE_SITE_UUID_KEY = 'braincube-site-uuid';
export function getProductUuid() {
    return sessionStorage.getItem(STORAGE_PRODUCT_UUID_KEY);
}
export function getSiteUuid() {
    return sessionStorage.getItem(STORAGE_SITE_UUID_KEY);
}
